import { SortDirectionEnum } from 'constants-activate';
import { FilterState } from './types';

export const DEFAULT_FILTER_STATE: FilterState = {
  sortBy: '_created', // Default to booking order
  sortDirection: SortDirectionEnum.Desc,
  bookingDateRange: {},
  reservationDateRange: {},
};

export const DEFAULT_PAGINATION = {
  start: 0,
  perPage: 100,
};
